import { useAccountTypeNavigation } from "@features/tickets/shared/hooks/useAccountTypeNavigation";
import { SYSTEMS_BREADCRUMB, SYSTEM_PATH, SYSTEMS_STRUCTURE_CRUMBS } from "./systems.constants";

export function useSystemsNavigation() {
  return useAccountTypeNavigation({
    path: SYSTEM_PATH,
    editLastBreadPath: SYSTEM_PATH,
    listBreadcrumb: SYSTEMS_BREADCRUMB.list,
    structureCrumbs: SYSTEMS_STRUCTURE_CRUMBS,
  });
}
